export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Home.vue'),
    meta: {
      title: 'Dashboard - System Gulftic',
      requiresAuth: false,
    },
  },

  // {
  //   path: "/notifications",
  //   name: "notifications",
  //   component: () => import("@/views/notifications/Notifications.vue"),
  //   meta: {
  //     title: "Notifications - System Gulftic",
  //     requiresAuth: false,
  //     action: "browse",
  //     pageTitle: "Notifications",
  //     breadcrumb: [
  //       {
  //         text: "Notifications",
  //         active: true
  //       }
  //     ]
  //   }
  // },

  {
    path: '/user-profile',
    name: 'user-profile',
    component: () => import('@/views/user-profile/UserProfile.vue'),
  },
]
